import {Button, Col, Row} from 'antd';
import ModalForm from 'components/ModalForm';
import Toast from 'components/Toast';
import {AuthContext} from 'context/Auth.context';
import moment from 'moment';
import {useContext, useEffect, useState} from 'react';
import SERVICES from 'services';
import fields from './applications.form';
import './Applications.less';

interface IAppDataTypes {
	id: number;
	studentID: number;
	userID: number;
	typeID: number;
	statusID: number;
	application: string;
	application_date: string;
	response?: string;
	response_date?: string;
	path: string;
	studentsName: string;
	studentsLastName: string;
	studentCode: string;
	userName: string;
	userLastName: string;
	typeName: string;
	statusName: string;
}

const ApplicationCard = ({
	handleViewApplication,
	data
}: {
	data: IAppDataTypes;
	handleViewApplication: () => void;
}) => {
	return (
		<div className="ApplicationCard">
			<div className="title">
				<span>{data.typeName}</span>
			</div>
			<div className="description">
				<div className="info">
					<div id="about">Ուղված է՝</div>
					<div id="about-info">
						{data.userName} {data.userLastName}
					</div>
				</div>
				<div className="info">
					<div id="about">Կարգավիճակ՝</div>
					<div id="about-info">{data.statusName}</div>
				</div>
				<div className="info">
					<div id="about">Դիմումի ամսաթիվ՝</div>
					<div id="about-info">{moment(data.application_date).utc().format('DD-MM-YYYY')}</div>
				</div>
			</div>
			<div className="actions">
				<Button onClick={handleViewApplication} type="primary">
					Դիտել
				</Button>
			</div>
		</div>
	);
};

const Applications = () => {
	const [modalVisible, setModalVisible] = useState<'ADD' | 'VIEW' | false>(false);
	const [choosedApplication, setChoosedApplication] = useState({});
	const [formErrors, setFormErrors] = useState({});

	const {
		state: {student}
	} = useContext(AuthContext);

	const role = student ? 'STUDENT' : 'CANDIDATE';

	const [applications, setApplications] = useState([]);

	const handleAddApplication = (data: any) => {
		data.lecturerID = data.userID;
		delete data.userID;

		SERVICES.USER.createStudentApplication(data)
			.then(res => {
				Toast.success(res.message);
				handleGetApplications();
				setModalVisible(false);
			})
			.catch(e => {
				if (typeof e.message === 'string') {
					Toast.error(e.message);
				} else {
					setFormErrors(e.message);
				}
			});
	};

	const handleGetApplications = () => {
		SERVICES.USER.getStudentApplications()
			.then(res => {
				setApplications(res.data.data);
			})
			.catch(e => {
				if (typeof e.message === 'string') {
					Toast.error(e.message);
				}
			});
	};

	useEffect(handleGetApplications, []);

	return (
		<>
			<div className="container applications">
				<Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}}>
					<Col xs={24} sm={12} md={12} lg={12} xl={6}>
						<Button
							type="dashed"
							onClick={() => {
								setModalVisible('ADD');
							}}
							style={{
								margin: '0 15px 15px 0',
								width: '100%',
								height: '93%',
								boxShadow: '0px 3px 7px 1px rgba(0, 0, 0, 0.2)',
								color: '#002494',
								display: 'flex',
								flexDirection: 'row',
								alignItems: 'center',
								justifyContent: 'center'
							}}>
							<span style={{fontSize: 48, marginRight: 10}}>+</span>
							<span style={{fontSize: 24}}>ավելացնել</span>
						</Button>
					</Col>
					{applications.map((data, i) => (
						<Col key={i} sm={12} xs={24} md={12} lg={12} xl={6}>
							<ApplicationCard
								handleViewApplication={() => {
									setChoosedApplication(data);
									setModalVisible('VIEW');
								}}
								data={data}
							/>
						</Col>
					))}
				</Row>
			</div>
			<ModalForm
				getFieldsValues={() => new Promise<any>(res => res({data: choosedApplication}))}
				fields={fields(role)}
				title={'Դիմում'}
				visible={modalVisible}
				selectedRowIds={[0]}
				onCancel={() => setModalVisible(false)}
				onCreate={modalVisible === 'ADD' ? handleAddApplication : undefined}
				editModalType={'TAB'}
				addModalType={'TAB'}
				formErrors={formErrors}
				loading={false}
			/>
		</>
	);
};

export default Applications;
